/**
 * System / brand colors – single source of truth.
 * Change the blue here to update the system color across the app.
 */
export const BRAND_BLUE = '#62B6E8';
export const BRAND_BLUE_DARK = '#2F7FAE';
export const BRAND_BLUE_LIGHT = 'rgba(98, 182, 232, 0.15)';

export default {
  primary: BRAND_BLUE,
  primaryDark: BRAND_BLUE_DARK,
  primaryLight: BRAND_BLUE_LIGHT,
};
